// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import * as uiHelpers from "../ReportAbuseUIHelpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../_metronic/_partials/controls";
import { useReportAbuseUIContext } from "../ReportAbuseUIContext";

export function ReportAbuseTable({
  isLoading,
  reportAbuseListTotalCount,
  currentPage,
  setCurrentPage,
  reportAbuseList,
}) {
  // ReportAbuse UI Context
  const reportAbuseUIContext = useReportAbuseUIContext();
  const reportAbuseUIProps = useMemo(() => {
    return {
      ids: reportAbuseUIContext.ids,
      setIds: reportAbuseUIContext.setIds,
      queryParams: reportAbuseUIContext.queryParams,
      setQueryParams: reportAbuseUIContext.setQueryParams,
      openReceiptDialog: reportAbuseUIContext.openReceiptDialog,
      openDeleteDialog: reportAbuseUIContext.openDeleteDialog,
      openEditDialog: reportAbuseUIContext.openEditDialog,
    };
  }, [reportAbuseUIContext]);

  // Table columns
  const columns = [
    // {
    //   dataField: "id",
    //   text: "ID",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   style: {
    //     minWidth: "110px",
    //   },
    // },
    {
      dataField: "reported_user",
      text: "Reported User",
      // sort: true,
      // sortCaret: sortCaret,
      style: {
        minWidth: "110px",
      },
      formatter: columnFormatters.ReportedUserNameColumnFormatter,
    },
    {
      dataField: "reported_by",
      text: "Reported By",
      style: {
        minWidth: "110px",
      },
      formatter: columnFormatters.ReportedByNameColumnFormatter,
    },
    {
      dataField: "report_reason",
      text: "Report Reason",
      // sort: true,
      // sortCaret: sortCaret,
      style: {
        minWidth: "110px",
      },
      formatter: columnFormatters.ReportReasonColumnFormatter,
    },
    {
      dataField: "createdAt",
      text: "Date",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "110px",
      },
      formatter: columnFormatters.DateTimeColumnFormatter,
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openReceiptDialog: reportAbuseUIProps.openReceiptDialog,
        openDeleteDialog: reportAbuseUIProps.openDeleteDialog,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
    },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: reportAbuseListTotalCount ? reportAbuseListTotalCount : 0,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: reportAbuseUIProps.queryParams.pageSize,
    page: currentPage,
    onPageChange: (page) => {
      setCurrentPage(page);
    },
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination isLoading={isLoading} paginationProps={paginationProps}>
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-head-bg table-borderless table-vertical-center reportAbuse-table"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                data={reportAbuseList === null ? [] : reportAbuseList}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  reportAbuseUIProps.setQueryParams
                )}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: reportAbuseUIProps.ids,
                //   setIds: reportAbuseUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={reportAbuseList} />
              </BootstrapTable>
              <NoRecordsFoundMessage entities={reportAbuseList} />
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
